<script>
import MixedGridFilters from './MixedGridFilters';
import MixedGrid from '@maison/mixins/MixedGrid';
import BaseMixedGrid from '@maison/components/mixedGrid/BaseMixedGrid.vue';

export default {
  components: {
    BaseMixedGrid,
    MixedGridFilters,
  },

  mixins: [MixedGrid],
};
</script>

<template>
  <div>
    <mixed-grid-filters
      v-if="displayFilter"
      :filters="filtersWithLocalizedPrices"
      :empty-filters="emptyFilters"
      :products-count="filteredColumnsCount"
      :unique-id="uniqueId"
      :default-sort="defaultSort"
      :default-filters="activeFilters"
      :should-display-sellable="shouldDisplaySellable"
      :has-filters-in-url="hasFiltersInUrl"
      @on-sort-change="onSortChange"
      @on-filters-changed="onFiltersChanged"
    />

    <base-mixed-grid
      :filtered-columns="filteredColumns"
      :unique-id="uniqueId"
      :aligned-center="alignedCenter"
      :get-column-classes="getColumnClasses"
      :get-column-data="getColumnData"
      :get-component="getComponent"
      :title="title"
      :subtitle="subtitle"
      :heading-tag="headingTag"
      :ctas="ctas"
      :related-links="relatedLinks"
      :should-display-load-more="shouldDisplayLoadMore"
      :next-page="nextPage"
      :see-all="seeAll"
    />
  </div>
</template>
